export default __webpack_public_path__ + "static/media/Company_logo.0c02e289.png";